<template>
  <div class="fill-height"
    :style="[
      {'background-color': `#F4F4F4`} 
    ]"
  >
    <strategio-app-bar></strategio-app-bar>
    <v-main style="height:100vh">
      <div style="max-height:100%; overflow:auto">
        <user-form 
          :user-data="user" 
          :items-tree="subs"
          parent-route="/user/admin"
          back-button-text="Regresar"
        ></user-form>
      </div>

    </v-main>
  </div>
</template>

<script>
import StrategioAppBar from '../components/header-bar/strategio-app-bar.vue'
import UserForm from '../components/users/user-form.vue'

import adminStorage from '../storage/adminStorage'
import reportsStorage from '../storage/reportsStorage'
import eventBus from '../utils/eventBus'

export default {
  name: 'user-admin-by-id',
  data () {
    return {
      user: {},
      subs: [],
      message: ''
    }
  },
  beforeRouteUpdate (to, from, next) {
    // react to route changes...
    // don't forget to call next()
    this.loadUser(to.params.userID)
    next()
  },
  mounted () {
    this.loadUser(this.$route.params.userID)
  },
  methods: {
    loadUser (userID) {
      adminStorage.getAdminUsers({
        userID,
        fromCache: true,
        onSuccess: (user) => {
          this.user = user
        },
        onError: (error) => {
          console.warn(error)
          eventBus.$emit('open-custom-snack-bar', {message: 'No pudimos obtener los datos del usuario', itsOk: false})
        }
      })

      adminStorage.getSubscriptions({
        userID,
        onSuccess: (subs) => {
          this.buildTreeItemsSubscriptions(subs)
        },
        onError: (error) => {
          console.warn(error)
          eventBus.$emit('open-custom-snack-bar', {message: 'No pudimos obtener las subscripciones del usuario', itsOk: false})
        }
      })
    },
    buildTreeItemsSubscriptions (subs) {
      reportsStorage.getData({
        forceLoad: false,
        onSuccess: (data) => {
          this.subs = reportsStorage.buildTree(subs)
          console.warn(this.subs)
        },
        onError: (error) => {
          let message = 'Error desconocido'
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            // console.log(error.response.data)
            // console.log(error.response.status);
            // console.log(error.response.headers);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            // console.log(error.request)
            message = 'No pudimos obtener respuesta del servidor'
          } else {
            // Something happened in setting up the request that triggered an Error
            message = `Error desconocido: ${error.message}`
          }
          eventBus.$emit('open-custom-snack-bar', {message, itsOk: false})
        }
      })
    }
  },
  components: {
    StrategioAppBar,
    UserForm
  }
}
</script>



// WEBPACK FOOTER //
// src/routes/user-admin-by-id.vue